import React from 'react';
import {
    Drawer,
    Box,
    Typography,
    IconButton,
    Stack,
    Avatar,
    useMediaQuery,
    useTheme,
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import EventNoteIcon from '@mui/icons-material/EventNote';
import AutomationHistoryPanel from './AutomationHistoryPanel';
import { usePreferences } from '../contexts/PreferencesContext';

const AutomationHistoryDrawer = ({ open, onClose, rule, triggerType, onLastRunLoaded }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const { t } = usePreferences();

    if (!rule?.id) {
        return null;
    }

    const title = t(`pages.automations.types.${triggerType}.title`);

    return (
        <Drawer
            anchor="right"
            open={open}
            onClose={onClose}
            keepMounted={false}
            disableRestoreFocus
        >
            <Box sx={{ width: isMobile ? '100vw' : 420, height: '100%', display: 'flex', flexDirection: 'column' }}>
                <Box sx={{ p: 2.5, borderBottom: '1px solid', borderColor: 'divider' }}>
                    <Stack direction="row" alignItems="center" spacing={1.5}>
                        <IconButton onClick={onClose} edge="start" aria-label="back">
                            <ArrowBackIcon />
                        </IconButton>
                        <Avatar sx={{ bgcolor: 'primary.main', color: 'primary.contrastText', width: 40, height: 40 }}>
                            <EventNoteIcon fontSize="small" />
                        </Avatar>
                        <Box sx={{ minWidth: 0 }}>
                            <Typography variant="h6" sx={{ fontWeight: 700, lineHeight: 1.2 }}>
                                {t('pages.automations.history')}
                            </Typography>
                            <Typography variant="caption" color="text.secondary" noWrap>
                                {title}
                            </Typography>
                        </Box>
                    </Stack>
                </Box>

                <Box sx={{ flex: 1, overflow: 'auto', p: 2 }}>
                    <AutomationHistoryPanel
                        ruleId={rule.id}
                        enabled={open}
                        onLastRunLoaded={onLastRunLoaded}
                    />
                </Box>
            </Box>
        </Drawer>
    );
};

export default AutomationHistoryDrawer;
